
import { Link } from "react-router-dom"
import {
  BadgeCheck,
  Bell,
  CreditCard,
  LogOut,
  Sparkles,
  Settings,
} from "lucide-react"
import {
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { useUserRole } from "@/hooks/useUserRole"

interface UserMenuContentProps {
  user: {
    name: string
    email: string
    avatar: string
  }
  onSignOut: () => void
}

export function UserMenuContent({ user, onSignOut }: UserMenuContentProps) {
  const { userRole, isLoading } = useUserRole();

  return (
    <>
      <DropdownMenuLabel className="p-0 font-normal">
        <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
          <Avatar className="h-8 w-8 rounded-lg">
            <AvatarImage src={user.avatar} alt={user.name} />
            <AvatarFallback className="rounded-lg">
              {user.name === "Welcome" ? "W" : user.name.substring(0, 2).toUpperCase()}
            </AvatarFallback>
          </Avatar>
          <div className="grid flex-1 text-left text-sm leading-tight">
            <span className="truncate font-semibold">{user.name}</span>
            <span className="truncate text-xs text-muted-foreground">{user.email}</span>
          </div>
        </div>
      </DropdownMenuLabel>
      <DropdownMenuSeparator />
      
      {!isLoading && userRole !== 'sys_admin' && (
        <>
          <DropdownMenuGroup>
            <DropdownMenuItem>
              <Sparkles className="mr-2 size-4" />
              Upgrade to Pro
            </DropdownMenuItem>
          </DropdownMenuGroup>
          <DropdownMenuSeparator />
        </>
      )}
      
      <DropdownMenuGroup>
        <DropdownMenuItem asChild>
          <Link to="/settings">
            <BadgeCheck className="mr-2 size-4" />
            Profile
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/settings/account">
            <CreditCard className="mr-2 size-4" />
            Account
          </Link>
        </DropdownMenuItem>
        {!isLoading && userRole === 'sys_admin' && (
          <DropdownMenuItem asChild>
            <Link to="/admin">
              <Settings className="mr-2 size-4" />
              Admin Settings
            </Link>
          </DropdownMenuItem>
        )}
        <DropdownMenuItem>
          <Bell className="mr-2 size-4" />
          Notifications
        </DropdownMenuItem>
      </DropdownMenuGroup>
      <DropdownMenuSeparator />
      <DropdownMenuItem onClick={onSignOut}>
        <LogOut className="mr-2 size-4" />
        Log out
      </DropdownMenuItem>
    </>
  )
}
